<!--视频播放-->
<template>
  <Layer :layerName="layerName" maskDirection="Middle" :visible="visible">
    <div class="dlrLayer-middle dlrVideoPlay">
      <div class="dlrVideoPlay-box">
        <h2 class="dlrVideoPlay-tit">
          <span>{{ video.name }}</span
          ><i class="dlrVideoPlay-close" @click="close"></i>
        </h2>
        <div class="dlrVideoPlay-show">
          <div id="playerContainer" class="dlrVideoPlay-playerContainer"></div>
        </div>
      </div>
    </div>
    <div class="dlrLayer-mask"></div>
  </Layer>
</template>
<script>
import util from '../../utils/util';
import Layer from '../Layer';
import * as layerNames from '../../services/layerName';
import layerManager from '../../services/layer.manager';
export default {
  name: 'VideoPlayer',
  props: {
    video: {
      type: Object,
      default: function () {
        return {
          name: '',
          videoId: ''
        };
      }
    }
  },
  components: {
    Layer
  },
  data () {
    return {
      layerName: layerNames.VIDEO_PLAYER,
      player: null,
      visible: true
    };
  },
  mounted () {
    this.$nextTick(() => {
      this.createPlayer();
    });
  },
  methods: {
    createPlayer () {
      const self = this;
      self.initPlayerScript(() => {
        self.player = window.AHVP.newPlayer({
          mid: self.video.videoId,
          autostart: true,
          container: 'playerContainer'
        });
      });
    },
    close () {
      const self = this;
      self.destroyPlayer();
      self.visible = false;
      setTimeout(() => {
        layerManager.openVideoList();
      }, 400);
    },
    destroyPlayer () {
      const self = this;
      if (self.player) {
        self.player.destroy();
      }
    },
    initPlayerScript (callback) {
      util.loadScript({
        id: 'VideoPlayerJs',
        src: 'https://p-vp.autohome.com.cn/api/player?direct=1',
        callback: callback
      });
    }
  }
};
</script>
<style lang="scss">
.dlrVideoPlay {
  background: rgba(0, 0, 0, 1);
  width: 90%;
  &-box {
  }
  &-tit {
    font-size: ptrd(36px);
    color: #fff;
    padding: ptrd(24px) ptrd(30px);
    line-height: ptrd(44px);
    position: relative;
  }
  &-close {
    position: absolute;
    top: ptrd(24px);
    right: ptrd(30px);
    width: ptrd(44);
    height: ptrd(44);
    vertical-align: top;
    background-image: url(data:image/png;base64,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);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: ptrd(44);
  }
  &-show {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    tr,
    td {
      vertical-align: middle;
    }
  }
  &-playerContainer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    bottom: 0;
  }
}
</style>